var map = {
	"./Annexes/index.vue": "./src/components/Annexes/index.vue",
	"./AnnexesList/index.vue": "./src/components/AnnexesList/index.vue",
	"./Breadcrumb/index.vue": "./src/components/Breadcrumb/index.vue",
	"./Button/index.vue": "./src/components/Button/index.vue",
	"./Dialog/index.vue": "./src/components/Dialog/index.vue",
	"./Email/Send.vue": "./src/components/Email/Send.vue",
	"./Examination/index.vue": "./src/components/Examination/index.vue",
	"./Form/index.vue": "./src/components/Form/index.vue",
	"./HeaderSearch/index.vue": "./src/components/HeaderSearch/index.vue",
	"./IconSelect/index.vue": "./src/components/IconSelect/index.vue",
	"./Page/index.vue": "./src/components/Page/index.vue",
	"./Puchase/index.vue": "./src/components/Puchase/index.vue",
	"./Sale/index.vue": "./src/components/Sale/index.vue",
	"./SvgIcon/index.vue": "./src/components/SvgIcon/index.vue",
	"./Table/com/handle.vue": "./src/components/Table/com/handle.vue",
	"./Table/index.vue": "./src/components/Table/index.vue",
	"./Tree/index.vue": "./src/components/Tree/index.vue",
	"./VueQuillEditor/div/index.vue": "./src/components/VueQuillEditor/div/index.vue",
	"./VueQuillEditor/div/textareaModule.vue": "./src/components/VueQuillEditor/div/textareaModule.vue",
	"./VueQuillEditor/index.vue": "./src/components/VueQuillEditor/index.vue",
	"./VueQuillEditorMerchandise/div/index.vue": "./src/components/VueQuillEditorMerchandise/div/index.vue",
	"./VueQuillEditorMerchandise/div/textareaModule.vue": "./src/components/VueQuillEditorMerchandise/div/textareaModule.vue",
	"./VueQuillEditorMerchandise/index.vue": "./src/components/VueQuillEditorMerchandise/index.vue",
	"./VueQuillEditorone/div/index.vue": "./src/components/VueQuillEditorone/div/index.vue",
	"./VueQuillEditorone/index.vue": "./src/components/VueQuillEditorone/index.vue",
	"./citySelect/index.vue": "./src/components/citySelect/index.vue",
	"./collapse/index.vue": "./src/components/collapse/index.vue",
	"./dialogBox/index.vue": "./src/components/dialogBox/index.vue",
	"./drawer/index.vue": "./src/components/drawer/index.vue",
	"./dropDown/index.vue": "./src/components/dropDown/index.vue",
	"./emailContent/index.vue": "./src/components/emailContent/index.vue",
	"./emailTemplate/index.vue": "./src/components/emailTemplate/index.vue",
	"./inputs/com/date/index.vue": "./src/components/inputs/com/date/index.vue",
	"./inputs/com/input/index.vue": "./src/components/inputs/com/input/index.vue",
	"./inputs/com/numberInput/index.vue": "./src/components/inputs/com/numberInput/index.vue",
	"./inputs/com/select/index.vue": "./src/components/inputs/com/select/index.vue",
	"./inputs/inputs.vue": "./src/components/inputs/inputs.vue",
	"./list/index.vue": "./src/components/list/index.vue",
	"./mailZone/index.vue": "./src/components/mailZone/index.vue",
	"./productView/index.vue": "./src/components/productView/index.vue",
	"./radioTable/index.vue": "./src/components/radioTable/index.vue",
	"./tab/index.vue": "./src/components/tab/index.vue",
	"./tag/index.vue": "./src/components/tag/index.vue",
	"./treeSelect/index.vue": "./src/components/treeSelect/index.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components sync recursive \\.vue$";